import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { BubbleMenu } from '@tiptap/extension-bubble-menu';
import Underline from '@tiptap/extension-underline';
import styled from 'styled-components';
import React, { forwardRef, useEffect, useCallback, useState, useRef } from 'react';
import { CommentExtension, getNewComment } from '../extensions/comment';
import { Form, Input, Radio } from 'antd';
import { styleVariables } from '../../../style';
import { PrimaryButton, SecondaryButton } from '../../button';
import { useCommentManager } from '../hooks/use-comment-manager';
import { CommentPopup } from './comment-popup.component';
import ControlledBubbleMenuComment from '../extensions/controlled-bubble-comment';
import TextStyle from '@tiptap/extension-text-style';
import { CustomTextStyle } from '../extensions/custom-text-style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledLayout = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledLayout",
  componentId: "sc-1d2iawe-0"
})([".tiptap{margin-bottom:", ";}.my-comment{position:relative;cursor:pointer;transition:filter 0.2s ease;&:hover{filter:brightness(0.9) saturate(1.1);}}custom-class{background-color:", ";}.ProseMirror{padding:", ";border:1px solid ", ";border-radius:", ";}p.is-editor-empty:first-child::before{color:", ";font-style:italic;content:attr(data-placeholder);float:left;height:0;pointer-events:none;}"], styleVariables.margin.large, function (props) {
  return props.theme.color.primary;
}, styleVariables.padding.large, styleVariables.colors.gray9, styleVariables.borderRadius.medium, function (props) {
  return props.theme.color.borderDefault;
});
var StyledEditorContent = styled(EditorContent).withConfig({
  displayName: "editor-commentcomponent__StyledEditorContent",
  componentId: "sc-1d2iawe-1"
})(["max-height:", ";overflow-y:", ";& > *{pointer-events:", ";}"], function (props) {
  return props.scrollable ? '70vh' : 'none';
}, function (props) {
  return props.scrollable ? 'auto' : 'visible';
}, function (props) {
  return props.disabled && 'none';
});
var StyledCommentWrapper = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledCommentWrapper",
  componentId: "sc-1d2iawe-2"
})(["display:flex;flex-direction:column;padding:", ";border:1px solid ", ";border-radius:", ";background-color:", ";min-width:360px;max-width:400px;.ant-input-textarea-show-count{&::before{float:right;color:rgba(0,0,0,0.45);white-space:nowrap;content:attr(data-count);pointer-events:none;}&::after{clear:both;content:' ';display:block;}}"], styleVariables.padding.large, styleVariables.colors.gray9, styleVariables.borderRadius.medium, function (props) {
  return props.theme.color.backgroundPrimary;
});
var StyledGroupButton = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledGroupButton",
  componentId: "sc-1d2iawe-3"
})(["display:flex;justify-content:flex-end;margin-top:", ";gap:", ";"], styleVariables.margin.medium, styleVariables.margin.small);
var StyledButton = styled(Radio.Button).withConfig({
  displayName: "editor-commentcomponent__StyledButton",
  componentId: "sc-1d2iawe-4"
})(["width:10px;height:16px;background:", " !important;margin-right:", ";"], function (props) {
  return props.$color;
}, styleVariables.margin.small);
var highlightColors = [styleVariables.highlightColors.color1, styleVariables.highlightColors.color2, styleVariables.highlightColors.color3, styleVariables.highlightColors.color4, styleVariables.highlightColors.color5];
export var EditorComment = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      content = _ref.content,
      showComment = _ref.showComment,
      disabled = _ref.disabled,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      onAnswerComment = _ref.onAnswerComment,
      comments = _ref.comments,
      setComments = _ref.setComments,
      onDeleteAnswerComment = _ref.onDeleteAnswerComment,
      onUpdateAnswerComment = _ref.onUpdateAnswerComment,
      labels = _ref.labels,
      _ref$loadingComment = _ref.loadingComment,
      loadingComment = _ref$loadingComment === void 0 ? false : _ref$loadingComment;

  var _useCommentManager = useCommentManager({
    comments: comments,
    setComments: setComments
  }),
      hoveredCommentId = _useCommentManager.hoveredCommentId,
      popupPosition = _useCommentManager.popupPosition,
      isEditingComment = _useCommentManager.isEditingComment,
      commentValue = _useCommentManager.commentValue,
      handleCommentActivated = _useCommentManager.handleCommentActivated,
      handleCommentEditClick = _useCommentManager.handleCommentEditClick,
      handleCommentEdit = _useCommentManager.handleCommentEdit,
      handleCommentDelete = _useCommentManager.handleCommentDelete,
      handleCommentUpdate = _useCommentManager.handleCommentUpdate,
      handleCancelUpdateComment = _useCommentManager.handleCancelUpdateComment,
      setCommentValue = _useCommentManager.setCommentValue;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      editable = _useState[0],
      setEditable = _useState[1];

  var editor = useEditor({
    extensions: [StarterKit, Underline, BubbleMenu, TextStyle, CustomTextStyle, CommentExtension.configure({
      HTMLAttributes: {
        "class": 'my-comment'
      },
      onCommentActivated: handleCommentActivated
    })],
    content: content || '',
    onUpdate: function onUpdate() {
      onChange === null || onChange === void 0 ? void 0 : onChange(editor.getHTML());
    }
  });
  useEffect(function () {
    if (!editor) return;
    return function () {
      return editor.destroy();
    };
  }, [editor]);
  useEffect(function () {
    if (editor) {
      editor.setEditable(editable);
    }
  }, [editable, editor]);
  useEffect(function () {
    var commentElements = document.querySelectorAll('[data-comment-id]');
    commentElements.forEach(function (element) {
      element.addEventListener('click', handleCommentEditClick);
    });
    return function () {
      commentElements.forEach(function (element) {
        element.removeEventListener('click', handleCommentEditClick);
      });
    };
  }, [content, handleCommentEditClick]);
  var handleSave = useCallback(function (value) {
    var color = value.color,
        content = value.content;
    var newComment = getNewComment(content);
    editor === null || editor === void 0 ? void 0 : editor.commands.setComment(newComment.id, color);
    setEditable(true);
    setComments(function (prev) {
      return [].concat(_toConsumableArray(prev), [newComment]);
    });
    onAnswerComment(newComment.id, content, editor.getHTML());
    form.resetFields();
    setEditable(false);
  }, [form, editor, onAnswerComment]);
  var handleCancel = useCallback(function () {
    form.resetFields();
  }, [form]);
  var handleDeleteComment = useCallback(function (commentId, editor) {
    if (commentId) {
      editor.commands.unsetComment(commentId);
      onDeleteAnswerComment(commentId, editor.getHTML());
      handleCommentDelete();
    }
  }, []);
  var prevLoadingRef = useRef(loadingComment);
  useEffect(function () {
    if (prevLoadingRef.current && !loadingComment) {
      handleCommentUpdate();
    }

    prevLoadingRef.current = loadingComment;
  }, [loadingComment, handleCommentUpdate]);
  var handleSaveUpdateComment = useCallback(function (commentId, content, editor) {
    if (commentId && content) {
      setComments(function (prev) {
        return prev.map(function (comment) {
          return comment.id === commentId ? _objectSpread(_objectSpread({}, comment), {}, {
            content: content
          }) : comment;
        });
      });
      onUpdateAnswerComment(commentId, content, editor.getHTML());
    }
  }, [onUpdateAnswerComment, setComments]);

  var updateCommentChange = function updateCommentChange(value) {
    setCommentValue(value);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledLayout, {
      ref: ref,
      children: [/*#__PURE__*/_jsx(StyledEditorContent, {
        editor: editor,
        disabled: disabled,
        scrollable: scrollable,
        contentEditable: false
      }), /*#__PURE__*/_jsx(CommentPopup, {
        position: popupPosition,
        commentId: hoveredCommentId,
        content: commentValue,
        isEditing: isEditingComment,
        onEdit: handleCommentEdit,
        onDelete: function onDelete(commentId) {
          return handleDeleteComment(commentId, editor);
        },
        onSave: function onSave(commentId, content) {
          return handleSaveUpdateComment(commentId, content, editor);
        },
        onCancel: handleCancelUpdateComment,
        onUpdateContent: updateCommentChange,
        labels: labels,
        loading: loadingComment
      })]
    }), editor && showComment && /*#__PURE__*/_jsx(ControlledBubbleMenuComment, {
      editor: editor,
      className: "p-1 border rounded-lg border-slate-400",
      tippyOptions: {
        hideOnClick: false
      },
      children: /*#__PURE__*/_jsx(StyledCommentWrapper, {
        children: /*#__PURE__*/_jsxs(Form, {
          name: "comment-form",
          form: form,
          initialValues: {
            color: highlightColors[0],
            content: ''
          },
          onFinish: handleSave,
          children: [/*#__PURE__*/_jsx("h4", {
            children: labels.comment
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "color",
            label: labels.selectColor,
            children: /*#__PURE__*/_jsx(Radio.Group, {
              children: highlightColors.map(function (color) {
                return /*#__PURE__*/_jsx(StyledButton, {
                  value: color,
                  $color: color
                });
              })
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "content",
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              rows: 6,
              autoSize: {
                minRows: 6,
                maxRows: 8
              },
              placeholder: "Add comments"
            })
          }), /*#__PURE__*/_jsxs(StyledGroupButton, {
            children: [/*#__PURE__*/_jsx(SecondaryButton, {
              onClick: handleCancel,
              disabled: loadingComment,
              children: labels.cancel
            }), /*#__PURE__*/_jsx(PrimaryButton, {
              type: "primary",
              htmlType: "submit",
              loading: loadingComment,
              children: labels.save
            })]
          })]
        })
      })
    })]
  });
});